module.exports = __webpack_public_path__ + "img/no-media.ab89b982.png";